export const normalizeDate = (dateStr) => {
  if (dateStr === "" || dateStr === null || dateStr === undefined) {
    return null;
  }

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;

  date.setHours(0, 0, 0, 0);
  return date;
};
